import debounce from 'lodash/debounce';
import { useEffect, useMemo, useState } from 'react';
import * as Y from 'yjs';

type useConvertObservedYXmlFragmentProps<T> = {
  fragment?: Y.XmlFragment;
  convertFunction: (v: Y.XmlFragment) => T;
};

export function useConvertObservedYXmlFragment<T>(props: useConvertObservedYXmlFragmentProps<T>) {
  const { fragment, convertFunction } = props;
  const [observeChange, setObserveChange] = useState(0);

  const result = useMemo(
    () => (fragment !== undefined ? convertFunction(fragment) : null),
    // observeChange is needed in dep array, but it's not being used in useMemo callback
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [fragment, convertFunction, observeChange]
  );

  useEffect(() => {
    const triggerObserveChange = debounce(() => {
      setObserveChange(prevState => prevState + 1);
    }, 300);

    fragment?.observeDeep(triggerObserveChange);
    return () => fragment?.unobserveDeep(triggerObserveChange);
  }, [fragment]);

  return result;
}
